import { computed, ref } from 'vue';
import { useDisplay } from 'vuetify';

// shared state for the side bar
const sideBarOpen = ref(false);
const selectedEntity = ref<'user' | 'group' | null>(null);
const selectedEntityUid = ref<string | null>(null);
const sideBarSubTitle = ref<string | null>(null);

export function useSideBar() {
  const { smAndDown, width } = useDisplay();

  const openSideBar = (entity: 'user' | 'group', uid: string) => {
    selectedEntity.value = entity;
    selectedEntityUid.value = uid;
    setTimeout(() => {
      // delay to allow the transition to finish
      sideBarOpen.value = true;
    }, 50);
  };

  const closeSideBar = () => {
    sideBarOpen.value = false;
    sideBarSubTitle.value = null;
    // delay to allow the transition to finish
    setTimeout(() => {
      selectedEntity.value = null;
      selectedEntityUid.value = null;
    }, 100);
  };

  const sideBarWidth = computed(() => {
    const calculatedWidth = smAndDown.value ? width.value : width.value / 3;
    // if the width is less than 600px, it starts to look bad
    if (smAndDown.value) {
      return calculatedWidth < 600 ? 680 : calculatedWidth;
    }
    return calculatedWidth;
  });

  return {
    sideBarOpen,
    selectedEntity,
    selectedEntityUid,
    sideBarWidth,
    openSideBar,
    closeSideBar,
  };
}
